import React from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";

// Tiny in-app heatmap for the Admin Scans tab. No API key, free OSM tiles.
// summary rows: { city, region, country, scans, lat, lng, last_seen }
export default function ScanMap({ summary }) {
  const points = (summary || []).filter((s) => s.lat != null && s.lng != null);
  const max = points.reduce((m, p) => Math.max(m, p.scans || 0), 1);

  // Default to Cape Town if we don't have any geo points yet.
  const center = points.length
    ? [
        points.reduce((s, p) => s + p.lat, 0) / points.length,
        points.reduce((s, p) => s + p.lng, 0) / points.length,
      ]
    : [-33.9, 18.6];

  const zoom = points.length > 1 ? 5 : points.length === 1 ? 9 : 5;

  return (
    <div className="relative border border-black bg-white" data-testid="scan-map">
      <div className="h-[320px] w-full">
        <MapContainer
          center={center}
          zoom={zoom}
          scrollWheelZoom={false}
          style={{ height: "100%", width: "100%", background: "#f5f5f5" }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {points.map((p, i) => {
            const radius = 6 + Math.round((p.scans / max) * 18);
            return (
              <CircleMarker
                key={i}
                center={[p.lat, p.lng]}
                radius={radius}
                pathOptions={{ color: "#0a0a0a", weight: 2, fillColor: "#FFCC00", fillOpacity: 0.85 }}
              >
                <Tooltip direction="top" offset={[0, -4]} opacity={1}>
                  <div style={{ fontFamily: "ui-monospace, monospace", fontSize: 12 }}>
                    <strong>{p.city || "Unknown city"}</strong>
                    {p.region ? `, ${p.region}` : ""}
                    {p.country ? ` · ${p.country}` : ""}
                    <br />
                    {p.scans} scan{p.scans === 1 ? "" : "s"}
                  </div>
                </Tooltip>
              </CircleMarker>
            );
          })}
        </MapContainer>
      </div>
      {points.length === 0 && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="bg-white border border-black px-4 py-2 label-tag">
            No geo-located scans yet — real visitors will appear here
          </div>
        </div>
      )}
    </div>
  );
}
